import { type ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { providePrimeNG } from 'primeng/config';
import { MessageService } from 'primeng/api';
import { routes } from './app.routes';
import { CCL } from './theme/CCL.theme';
import { es } from './language/es.json';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { targetHostInterceptor } from './core/interceptors/token.interceptor';
import { AppTitleStrategy } from './core/routing/title-strategy';
import { TitleStrategy } from '@angular/router';
import { PRIMENG_LICENSE_KEY } from '@shared/constants/primeng/primeng-license';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    { provide: TitleStrategy, useClass: AppTitleStrategy },
    provideHttpClient(withInterceptors([targetHostInterceptor])),
    MessageService,
    providePrimeNG({
      license: PRIMENG_LICENSE_KEY,
      theme: {
        preset: CCL,
        options: {
          darkModeSelector: '.dark',
        },
      },
      translation: es,
    }),
  ],
};
